module.exports = function() {
  return new Worker("/" + "typescript-transpiler.3826dd17.worker.js");
};